import { Component } from '@angular/core';

import { ReportDetailsService } from './report.details.service';

@Component({
  selector: 'lib-reports-wrapper',
  template: `<div class="reports"><router-outlet></router-outlet></div>`,
})
export class ReportsWrapperComponent {
   constructor( private reportDetails: ReportDetailsService ) {
      this.reportDetails.columns.subscribe().unsubscribe();
   }
}
